export const style = {
  wrapper: {
    background: `#f5f5f5`
  },
  nameSpan: {
    fontSize: `12px`
  },
  input: {
    maxWidth: `200px`,
    padding: `3px`,
    borderRadius: 0
  },
  hNotes: {
    marginBottom: `20px`
  },
  bNotes: {
    marginTop: `20px`
  },
  p: {
    fontSize: `12px`
  },
  button: {
    fontSize: `13px`,
    textAlign: `center`,
    padding: `5px 30px`,
    border: `2px solid white`,
    background: `white`,
    cursor: `pointer`,
    ':hover': {
      borderColor: `#666`
    }
  },
  submit: {
    color: `white`,
    background: `#a94545`,
    borderColor: `#a94545`,
    ':hover': {
      borderColor: `#a94545`,
      background: `white`,
      color: `#a94545`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/partials/AccountDetails/style/ColorBlind/editable.js